import React from 'react';
import {UeLink} from '../../wraps';
import styled from 'styled-components';
import {LinkProps} from '../../../types';
import {AccentColorProps, useAccentVariant} from 'epic-ue-theme';

const TextLinkWrapper = styled.span<AccentColorProps>`
    && {
        margin: 0;
        a.ue-link-wrap {
            transition: color 0.3s ${(p) => p.theme.easing};
            &:hover {
                color: ${({accentColor = 'sky', accentVariant}: AccentColorProps) =>
                    useAccentVariant(accentColor, accentVariant)};
            }
        }
    }
`;

export const TextLink = ({accentColor, accentVariant, ...rest}: LinkProps): JSX.Element => (
    <TextLinkWrapper accentColor={accentColor} accentVariant={accentVariant}>
        <UeLink {...rest} />
    </TextLinkWrapper>
);
